import * as actionTypes from "../Action/ActionTypes";
import * as actionReducer from "./ActionReducer";

const initialState = {
  OrgsOfAdmin: {
    error: null,
    request: null,
    response: null,
  },
  setAdmin: {
    error: null,
    request: null,
    response: null,
  },
};

const OrgAdminReducer = (state = initialState, action) => {
  switch (action.type) {

    case actionTypes.CLEAR_STATE:
      return actionReducer.clearState(state, action, initialState);

    case actionTypes.GET_ORGS_OF_ADMIN:
      return actionReducer.getOrgsOfAdmin(state, action);
    case actionTypes.GET_ORGS_OF_ADMIN_SUCCESS:
      return actionReducer.getOrgsOfAdminSuccess(state, action);
    case actionTypes.GET_ORGS_OF_ADMIN_FAIL:
      return actionReducer.getOrgsOfAdminFail(state, action);

    case actionTypes.SET_ADMIN:
      return actionReducer.setAdmin(state, action);
    case actionTypes.SET_ADMIN_SUCCESS:
      return actionReducer.setAdminSuccess(state, action);
    case actionTypes.SET_ADMIN_FAIL:
      return actionReducer.setAdminFail(state, action);

    default:
      return state;
  }
};

export { OrgAdminReducer };